import { DropTarget } from './DropTarget.js';

export { FileDropTarget };

/**
 * A drop target for files.
 *
 * @author rkoppe <roland.koppe@awi.de>
 * @memberof vef.ui.dnd
 */
class FileDropTarget extends DropTarget {

    _drop(event) {
        if (event.dataTransfer && event.dataTransfer.files) {
            let files = event.dataTransfer.files;
            this.fire('drop', files, event);
        }
    }
}